import clear from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-job-plan/actions/clear';
import displayNotification from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-job-plan/actions/displayNotification';
import editItem from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-job-plan/actions/editItem';
import generateReport from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-job-plan/actions/generateReport';
import initialize from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-job-plan/actions/initialize';
import onChange from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-job-plan/actions/onChange';
import quantityCustomValidation from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-job-plan/actions/quantityCustomValidation';
import reset from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-job-plan/actions/reset';
import timeCustomValidation from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-job-plan/actions/timeCustomValidation';
import updateJobPlan from '@gov.wa.lni/application.janitorial-workload-calculator/source/components/lni-janitorial-job-plan/actions/updateJobPlan';

export default {
    clear,
    displayNotification,
    editItem,
    generateReport,
    initialize,
    onChange,
    quantityCustomValidation,
    reset,
    timeCustomValidation,
    updateJobPlan,
};